import React, { useState } from "react";

const Footer = () => {
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Thank you! We will get in touch with you at ${email}`);
  };

  return (
    <div id="contact">
      <div className="min-h-32 w-full bg-[#FFCD29] flex items-center p-4 sm:p-8">
        <form
          onSubmit={handleSubmit}
          className="flex flex-col sm:flex-row gap-4 items-center w-full max-w-4xl mx-auto"
        >
          <label
            htmlFor="email"
            className="text-black text-lg font-medium text-center sm:text-left"
          >
            Get in touch with me:
          </label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email address"
            className="p-2 rounded w-full sm:flex-1 max-w-sm"
            required
          />
          <button
            type="submit"
            className="bg-black text-white p-2 px-4 rounded hover:bg-gray-800 transition-colors w-full sm:w-auto"
          >
            Let's Connect
          </button>
        </form>
      </div>
    </div>
  );
};

export default Footer;
